import { Component, Vue } from 'vue-property-decorator';

@Component<Home>({
  components: {
    //
  },
})
export default class Home extends Vue {

  public mounted() {
    //
  }

  protected getStyle() {
    if (window.location.href.includes('par')) return 'par';
    else if (window.location.href.includes('esi')) return 'esi';
    else if (window.location.href.includes('bib')) return 'bib';
    else return '';
  }

}
